module.exports = __webpack_public_path__ + "media/images/athletes/2216-75a5d0bf6bf436facd66a266420c57a3.png";